import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import routerPath from "./routerPath";
import Login from "../components/login/login";
import { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import config from "../config";
// import ErrorPage from "../components/errorPage/errorPage";
import billLineSettings from "../billLineSettings";
import useLocalStorage from "../hooks/useLocalstorage";
import Layout from "../components/layout/Main";
import { merge } from "lodash";
import { useSetAccess } from "../provider/AccessProvider";
import { default as BillingDashboard } from "../components/billing";

const RouterAuthorizer = () => {
  var dispatch = useDispatch();
  const [mainUserShopDetails] = useLocalStorage("mainUserShopDetails", []);
  const { isLoggedIn } = useSelector((state) => state.isLoggedIn);
  const [collapse, setCollapse] = useState(false);
  const [, setAccess] = useSetAccess();
  useEffect(() => {
    setTimeout(async () => {
      await Auth.currentAuthenticatedUser()
        .then(async (res) => {
          console.log("currentAuthenticatedUser", res);
          var shopDetails = {};
          if (
            res.attributes["custom:userType"] &&
            res.attributes["custom:userType"] === "Employee"
          ) {
            // Employee & Outlet
            let employeeShopDetails = await getShopDetailsApi(
              res.attributes.sub
            );
            let ownerShopDetails = await getShopDetailsApi(
              res.attributes["custom:ownerShopId"]
            );

            const outletArray = await fetchOutlets(
              res.attributes["custom:ownerShopId"]
            );
            if (ownerShopDetails.userType === "Outlet") {
              let mainOwnerShopDetails = await getShopDetailsApi(
                ownerShopDetails.ownerShopId
              );
              ownerShopDetails = {
                ...ownerShopDetails,
                shopName: mainOwnerShopDetails.shopName,
                shopType: mainOwnerShopDetails.shopType,
              };
            }
            const outletObj = outletArray?.find(
              (i) => i.userPhoneNumber === employeeShopDetails.userPhoneNumber
            );

            // Outlet
            if (outletObj) {
              let outLetsShopDetails = await getShopDetailsApi(
                outletObj.userId
              );
              console.log("outLetsShopDetails111", outLetsShopDetails);
              shopDetails = {
                ...ownerShopDetails,
                settings: outLetsShopDetails.settings,
                categoryList: outLetsShopDetails.categoryList
                  ? outLetsShopDetails.categoryList
                  : {
                      OTHERS: {
                        subCategory: ["OTHERS"],
                        imageUrl: "",
                      },
                    },
                taxMaster: outLetsShopDetails.taxMaster
                  ? outLetsShopDetails.taxMaster
                  : [],
                userAddress: outLetsShopDetails.shopAddress,
                shopAddress: outLetsShopDetails.shopAddress,
                ownerShopId: outletObj.ownerShopId,
                userId: outletObj.userId,
                // empId: employeeShopDetails.userId,
                employeeName: employeeShopDetails.userName,
                userName: outletObj.userName,
                userPhoneNumber: outletObj.userPhoneNumber,
                shopPhoneNumber: ownerShopDetails.userPhoneNumber,
                smsPackage: ownerShopDetails.smsPackage,
                userId10Digit: outletObj.userId10Digit,
                userType: outletObj.userType,
                userPincode: outletObj.userPincode,
                outletArea: outletObj.outletArea,
                outletState: outletObj.outletState,
                customTaxType: outletObj.customTaxType,
                access: [
                  "generateReprintBill",
                  "cancelBill",
                  "customerManagement",
                  "inventoryManagement",
                  "editProductPrice",
                  "rewardRedeemLoyalty",
                  "reportsAndDashboard",
                  "vendorManagement",
                ],
                expensesType: outletObj.expensesType,
              };
              if (outLetsShopDetails.newBillsettings) {
                dispatch({
                  type: "INVOICE-NEWBILLSETTINGS",
                  payload: merge({}, ...outLetsShopDetails.newBillsettings),
                });
                if (outLetsShopDetails.taxMaster) {
                  dispatch({
                    type: "SET_TAX_LIST",
                    payload: outLetsShopDetails.taxMaster,
                  });
                }
              }
            } else {
              // Employee
              if (employeeShopDetails.unifiedAccess?.pos) {
                setAccess(employeeShopDetails.unifiedAccess.pos);
              }
              shopDetails = {
                ...ownerShopDetails,
                ...employeeShopDetails,
                categoryList: ownerShopDetails.categoryList
                  ? ownerShopDetails.categoryList
                  : {
                      OTHERS: {
                        subCategory: ["OTHERS"],
                        imageUrl: "",
                      },
                    },
                taxMaster: ownerShopDetails.taxMaster
                  ? ownerShopDetails.taxMaster
                  : [],
                ownerShopId: employeeShopDetails.ownerShopId,
                userId: employeeShopDetails.userId,
                employeeName: employeeShopDetails.userName,
                userPhoneNumber: employeeShopDetails.userPhoneNumber,
                shopPhoneNumber: ownerShopDetails.userPhoneNumber,
                smsPackage: ownerShopDetails.smsPackage,
                websiteContactPhoneNumber:
                  ownerShopDetails.websiteContactPhoneNumber,
              };
              if (ownerShopDetails.newBillsettings) {
                dispatch({
                  type: "INVOICE-NEWBILLSETTINGS",
                  payload: merge({}, ...shopDetails.newBillsettings),
                });
                if (shopDetails.taxMaster) {
                  dispatch({
                    type: "SET_TAX_LIST",
                    payload: shopDetails.taxMaster,
                  });
                }
              }
            }
            dispatchActions(shopDetails, null);
          } else {
            // Owner
            let shopDetails = await getShopDetailsApi(res.attributes.sub);
            var oD = await fetchOutlets(res.attributes.sub);
            if (!shopDetails.settings) {
              await updateSettings(res.attributes.sub);
              shopDetails = await getShopDetailsApi(res.attributes.sub);
            }
            if (shopDetails.newBillsettings) {
              dispatch({
                type: "INVOICE-NEWBILLSETTINGS",
                payload: merge({}, ...shopDetails.newBillsettings),
              });
            }
            if (shopDetails.taxMaster) {
              dispatch({
                type: "SET_TAX_LIST",
                payload: shopDetails.taxMaster,
              });
            }
            dispatchActions(shopDetails, oD);
          }
        })
        .catch((err) => {
          console.log("LOGINERROR", err);
          dispatch({
            type: "IS_LOGGEDIN",
            payload: false,
          });
        });
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  const getShopDetailsApi = async (id) => {
    var shopDetailsRes = await fetch(
      `${config.newApiGateway}/customer/createCustomerandgetCustomer`,
      {
        method: "POST",
        body: JSON.stringify({
          shopId: id,
          action: "getShopDetails",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }
    );
    shopDetailsRes = await shopDetailsRes.json();
    return shopDetailsRes.Items[0];
  };

  const dispatchActions = async (shopDetails, outlets) => {
    if (mainUserShopDetails.length > 0 && shopDetails.userType === "Shop") {
      const length = mainUserShopDetails.length;
      console.log("mainUserShopDetails", mainUserShopDetails[length - 1]);
      dispatch({
        type: "SET_SHOP_PROFILE",
        payload: mainUserShopDetails[length - 1],
      });
      dispatch({
        type: "SET_SETTINGS",
        payload: mainUserShopDetails[length - 1].settings,
      });
      if (mainUserShopDetails[length - 1]?.newBillsettings) {
        dispatch({
          type: "INVOICE-NEWBILLSETTINGS",
          payload: merge(
            {},
            ...mainUserShopDetails[length - 1]?.newBillsettings
          ),
        });
      }
    } else if (shopDetails.userType === "Outlet") {
      dispatch({
        type: "SET_SHOP_PROFILE",
        payload: shopDetails,
      });
      dispatch({
        type: "SET_SETTINGS",
        payload: shopDetails.settings,
      });
    } else {
      dispatch({
        type: "SET_SHOP_PROFILE",
        payload: shopDetails,
      });
      dispatch({
        type: "SET_SETTINGS",
        payload: shopDetails.settings,
      });
    }
    dispatch({
      type: "IS_LOGGEDIN",
      payload: true,
    });
    if (outlets) {
      dispatch({
        type: "SET_OUTLETS",
        payload: outlets,
      });
    }
  };

  const updateSettings = async (shopId) => {
    await Promise.all([
      fetch(`${config.newApiGateway}/tools/shopDetailsUpdate`, {
        method: "POST",
        body: JSON.stringify({
          userId: shopId,
          settings: billLineSettings,
          action: "settings",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        return data;
      })
      .catch((err) => {
        console.log("update settings", err);
      });
  };

  const fetchOutlets = async (shopId) => {
    try {
      var res = await fetch(`${config.newApiGateway}/outlet/getOutlet`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "fetch",
          shopId: shopId,
        }),
      });
      res = await res.json();
      if (res.code === "ERROR") {
        console.log("Err", res);
        return;
      }
      dispatch({
        type: "SET_OUTLETS",
        payload: res.data,
      });
      return res.data;
    } catch (err) {
      console.log("Err", err);
    }
  };

  return (
    <>
      {isLoggedIn ? (
        window.location.hash.substring(1) === "/login" ? (
          <Navigate to="/billing" replace />
        ) : (
          <Routes>
            <Route path="/billing" element={<BillingDashboard />} />
            <Route
              path="/*"
              element={
                <DashboardRoutes collapse={collapse} setCollapse={setCollapse} />
              }
            />
          </Routes>
        )
      ) : (
        <>
          <Login />
        </>
      )}
    </>
  );
};

const DashboardRoutes = ({ collapse, setCollapse }) => {
  const location = useLocation();
  const matchedRoute = routerPath.find(
    (data) => data.path === location.pathname
  );
  const Component = matchedRoute?.component;
  return (
    <Layout title={""} collapse={collapse} setCollapse={setCollapse}>
      {Component ? <Component /> : null}
    </Layout>
  );
};

export default RouterAuthorizer;
